import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'projects/core/src/authGuard';
import { ActivitiesDetailsComponent } from './activities-details/activities-details.component';

import { ActivitiesComponent } from './activities.component';

const routes: Routes = [
  { path: '', component: ActivitiesComponent,canActivate:[AuthGuard] },
  { path: 'activities-details/:id', component: ActivitiesDetailsComponent ,canActivate:[AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ActivitiesRoutingModule { }
